<template>
    <div class="fill-param">
        <input type="text" name="paramName" placeholder="参数名" v-model="paramName">
        <input type="text" name="paramValue" class="discription" v-model="paramValue" placeholder="参数描述信息"><i @click="addSelfParamEvent" title="添加" class="fa fa-plus" aria-hidden="true"></i>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'

export default {
    data() {
        return{
            paramName: '',
            paramValue: '',
            addParamData: {},
            isSuper: sessionStorage.getItem('isSuper'),
        }
    },
    mounted() {
       
    },
    computed: {
        ...mapState([
            'defaultParams'
        ])
    },
    methods: {
        // 将参数提交给父组件
        addSelfParamEvent() {
            if (this.paramName !== '' || this.paramValue !== '') {
                this.$emit('addParam', this.paramValue, this.paramName);
            } else {
                this.$notify.error({
                    message: '参数不能为空',
                    title: '提示',
                    offset: 100
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>
    .fill-param{
        margin: 5px 0;
        display: flex;
        justify-content: flex-start;
        input{
            margin-right: 10px;
            font-size: 13px;
            padding: 5px;
            width: 30%;
        }
        i{
            line-height: 32px;
        }
        .discription{
            width: 50%;
        }
        label:hover{
            cursor: pointer;
        }
    }
</style>
